import React, { useState } from 'react';
import ShippingSection from './ShippingSection';
import classNames from "classnames";
import loader from "../images/ajax-loader.gif";
import { CSSTransition } from 'react-transition-group';
import PropTypes from "prop-types";
import {
    PaymentElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";

const CheckoutForm = ({  
    showError,
    onSuccess,
    shippingState,
    deliveryChosen,
    paymentSucceeded }) => {

    const [processing, setProcessing] = useState(false);

    const stripe = useStripe();
    const elements = useElements();

    const buttonContents = (() => {
        if (processing) {      
            return <img src={loader} />;
        }

        if (paymentSucceeded) {
            return <span dangerouslySetInnerHTML={{ __html: "&check;" }}></span>;          
        }

        return <>Confirm payment</>;
    })();



    const handleSubmit = async ev => {
        ev.preventDefault();
        const stripeHasNotYetLoaded = !stripe || !elements;

        if (stripeHasNotYetLoaded) {
            return;
        }


        setProcessing(true);  

        const shippingDetails = deliveryChosen ? shippingState.shippingDetails : {};

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: "https://localhost:44363/temp/index",
                shipping: shippingDetails
            },
            redirect: 'if_required'
        });

        setProcessing(false);

        if (!error) {
            onSuccess();
            return;
        }

        if (error.type === "card_error" || error.type === "validation_error") {
            showError(error.message);
        } else {
            showError("An unexpected error occured.");
        }
    };

    const paymentElementOptions = {
        wallets: {
            applePay: 'never',
            googlePay: 'never'
        }
    };

    return (
        <CSSTransition
            in={!paymentSucceeded}
            timeout={1000}
            classNames="fade"
            unmountOnExit>
        <form id="paymentForm" onSubmit={handleSubmit}>
                {deliveryChosen ? <ShippingSection {...shippingState} /> : <></>}
         <PaymentElement id="payment-element" options={paymentElementOptions} />         
            <button
                disabled={processing || paymentSucceeded}
                className={classNames({ "confirm-payment": true, "payment-processing": processing, "payment-succeeeded":paymentSucceeded })}>
                {buttonContents}
            </button>
            </form>
    </CSSTransition>
    );
};
export default CheckoutForm;

CheckoutForm.propTypes = {
    shippingState: PropTypes.object.isRequired,
    paymentSucceeded: PropTypes.bool.isRequired,
    onSuccess: PropTypes.func.isRequired,
    deliveryChosen: PropTypes.bool.isRequired,
    showError: PropTypes.func.isRequired
}